import { Files } from "@phosphor-icons/react";
import { createAction } from "~/actions/registry";

/**
 * The command bar's "New project" — reached from the sidebar row and the settings section
 * header too, all three calling the same `openDialog({ kind: "newProject" })`. Visible
 * whenever a workspace is loaded: `projects.create` is "any authenticated workspace member"
 * server-side (§E-1), so this rides no narrower a gate than that.
 */
export const newProject = createAction({
  id: "projects.new",
  name: (ctx) => ctx.t("New project…"),
  section: (ctx) => ctx.t("Projects"),
  icon: Files,
  keywords: "create project new programme initiative",
  perform: (ctx) => ctx.shell.getState().openDialog({ kind: "newProject" }),
});

export const projectActions = [newProject];
